import { isEmpty } from 'lodash-es';
import { OrderAssistFormErrors } from '../../types';
import { SearchFormPropsValidation } from '../../components/search-form/types';

const errorMessages = (...params: string[]) => ({
  missingInput: `Please enter ${params[0]}`,
  invalidInput: `Please enter a valid ${params[0]}`,
});

export const validateTeladocSearchForm = ({
  formData,
}: SearchFormPropsValidation): [boolean, OrderAssistFormErrors] => {
  const { specialty, address, network } = formData;

  const errors: OrderAssistFormErrors = {};

  if (!address?.coordinates) {
    errors.address = errorMessages('address').invalidInput;
  }

  if (!specialty?.vimSpecialtyId) {
    errors.specialty = errorMessages('specialty').missingInput;
  }

  if (!network?.value) {
    errors.network = errorMessages('network').missingInput;
  }

  const hasErrors = !isEmpty(errors);
  return [hasErrors, errors];
};
